import { motion } from "framer-motion";

const DARK_BG = "#172033";
const CARD_BG = "#1E2A3B";
const ORANGE = "#E8470A";

function TipCard({ tip, index }) {
  const text = typeof tip === "string" ? tip : tip.description;
  const icon = typeof tip === "object" ? tip.icon : null;
  const label = typeof tip === "object" ? tip.title : null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.09, ease: "easeOut" }}
      viewport={{ once: true, margin: "-50px" }}
      style={{
        backgroundColor: CARD_BG,
        borderRadius: "16px",
        padding: "28px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      {/* Badge */}
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "36px",
        height: "36px",
        borderRadius: "10px",
        backgroundColor: "rgba(232,71,10,0.15)",
        flexShrink: 0,
      }}>
        {icon ? (
          <span style={{ fontSize: "18px", lineHeight: 1 }}>{icon}</span>
        ) : (
          <span style={{ color: ORANGE, fontSize: "12px", fontWeight: 800 }}>
            {String(index + 1).padStart(2, "0")}
          </span>
        )}
      </div>

      {label && (
        <p style={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#ffffff",
          margin: 0,
          lineHeight: 1.3,
        }}>
          {label}
        </p>
      )}

      <p style={{
        fontSize: "14px",
        lineHeight: 1.7,
        color: "rgba(255,255,255,0.62)",
        margin: 0,
      }}>
        {text}
      </p>
    </motion.div>
  );
}

export function TravelTips({ destination, tips }) {
  if (!tips || tips.length === 0) return null;

  return (
    <section id="tips" style={{ backgroundColor: DARK_BG, padding: "96px 0" }}>
      <div style={{ maxWidth: "1140px", margin: "0 auto", padding: "0 24px" }}>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true, margin: "-80px" }}
          style={{ marginBottom: "48px" }}
        >
          <span style={{
            display: "block",
            color: ORANGE,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}>
            Antes de partir
          </span>
          <h2 style={{
            fontSize: "clamp(28px, 3.5vw, 40px)",
            fontWeight: 800,
            color: "#ffffff",
            lineHeight: 1.15,
            margin: 0,
          }}>
            Consejos para viajar a {destination}
          </h2>
        </motion.div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: "16px",
        }}>
          {tips.map((tip, i) => (
            <TipCard key={i} tip={tip} index={i} />
          ))}
        </div>

      </div>
    </section>
  );
}
